const generateTimeArray = (date?: string): string[] => {
	// Use 15-minute increments: 00, 15, 30, 45
	const quarterHours = ['00', '15', '30', '45'];
	const times: string[] = [];

	const preselectedHour = date !== undefined ? parseInt(date?.split(':')[0]) : 0;
	// determine starting quarter index for preselected minutes
	const preselectedMinutes = date !== undefined ? parseInt(date?.split(':')[1]) : 0;
	let startQuarter = 0;
	if (preselectedMinutes <= 0) startQuarter = 0;
	else if (preselectedMinutes <= 15) startQuarter = 1;
	else if (preselectedMinutes <= 30) startQuarter = 2;
	else if (preselectedMinutes <= 45) startQuarter = 3;
	else startQuarter = 0;

	for (let h = preselectedHour; h < 24; h++) {
		for (let q = 0; q < 4; q++) {
			// if first hour, start from startQuarter
			if (h === preselectedHour && q < startQuarter) continue;

			const minute = quarterHours[q];
			let time = `${h}:${minute}`;
			if (h < 10) time = `0${time}`;
			times.push(time);
		}
	}

	// keep previous behaviour for end of day
	times.push('23:59');
	return times;
};

export default generateTimeArray;
